export default __webpack_public_path__ + "static/media/b3.1674d10f.jpg";